import React from "react";

const BuyerCardCompact = ({ row }) => (
  <div className="abr-match-row">
    <div className="abr-mr-id-score">
      #{row.id}
      <span className="abr-mr-pct">{row.score}%</span>
    </div>
    <div className="abr-mr-budget">{row.budget}</div>
    <div className="abr-mr-finance">
      <strong>{row.financeLabel}</strong> &middot; {row.timing}
    </div>
    <div className="abr-mr-musts">{row.musts}</div>
    <div className="abr-mr-brokerage">{row.brokerage}</div>
  </div>
);

export default BuyerCardCompact;
